import ExistingChat from '@/components/modules/chat/ExistingChat'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/app/chat/$conversationId')({
  component: ExistingChatRoute,
})

function ExistingChatRoute() {
  const { conversationId } = Route.useParams()
  return <ExistingChat conversationId={conversationId} />
}
